module.exports = __webpack_public_path__ + "img/section3_icon1.72966d55.png";